import * as React from "react";
const ExportIcon = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 12.499V3.01562"
      stroke="#807E7C"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7904 4.8737L9.9987 2.08203L7.20703 4.8737"
      stroke="#807E7C"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.28307 17.9174C3.55807 17.9174 2.06641 16.4258 2.06641 12.7008V12.5924C2.06641 9.24245 3.27474 7.70078 6.22474 7.42578"
      stroke="#807E7C"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6982 7.41797C16.6982 7.6763 17.9232 9.21797 17.9232 12.593V12.7013C17.9232 16.4263 16.4315 17.918 12.7065 17.918H10.8398"
      stroke="#807E7C"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ExportIcon;
